module.exports = __webpack_public_path__ + "static/media/cloudy-1-day.6627feca.svg";